import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src="https://colorlib.com/cdn-cgi/image/quality=80,format=auto,onerror=redirect,metadata=none/wp/wp-content/uploads/sites/2/404-error-template-3.png.webp" alt="" />
        </div>
    );
};

export default NotFound;